import { selector } from 'recoil';
import { cartState, orderState } from './Atoms';
import { fetchBenefits, fetchCategories, fetchInfo, fetchMenu } from '../utils/functions';

export const clientId = process.env.REACT_APP_ID || "demo"

export const cartStatus = selector({
  key: 'cartStatus',
  get: ({ get }) => {
    const cart: [] = get(cartState);
    const totalItems = cart.reduce((items, { qty }) => items + (qty), 0);
    const totalPrice = cart.reduce((total, { qty, price }) => total + (qty * price), 0);

    return {
      totalItems,
      totalPrice,
    }
  }
})

export const orderStatus = selector({
  key: 'orderStatus',
  get: ({ get }) => {
    const order: any = get(orderState);
    const orderValid = order ? true : false;

    return {
      orderValid
    }
  }
})

export const productsFetched = selector({
  key: 'products-cloud',
  get: async () => {
    const response = await fetchMenu();
    return response;
  },
});

export const benefitsFetched = selector({
  key: 'benefits-cloud',
  get: async () => {
    const response = await fetchBenefits();
    return response;
  },
});

export const categoriesFetched = selector({
  key: 'categories-cloud',
  get: ({ get }) => {
    return fetchCategories();
  },
});

export const infoFetched = selector({
  key: 'info-cloud',
  get: ({ get }) => {
    return fetchInfo(clientId);
  },
});